"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Switch = require("./Switch.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["labelText", "id", "disabled", "data-testid", "aria-labelledby", "aria-describedby", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * @description This component uses the same props as a native checkbox, but it is styled as a switch.
 * @param labelText
 * @param id
 * @param disabled
 * @param dataTestId
 * @param ariaLabelledBy
 * @param ariaDescribedBy
 * @param className
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
var Switch = exports.Switch = (0, _react.memo)(function (_ref) {
  var labelText = _ref.labelText,
    id = _ref.id,
    disabled = _ref.disabled,
    dataTestId = _ref['data-testid'],
    ariaLabelledBy = _ref['aria-labelledby'],
    ariaDescribedBy = _ref['aria-describedby'],
    className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _react["default"].createElement(_Switch.StyledWrapper, {
    disabled: disabled,
    "data-testid": dataTestId,
    className: className
  }, _react["default"].createElement(_Switch.StyledSwitch, null, labelText && _react["default"].createElement(_Switch.StyledSwitchCheckboxLabel, {
    labelFor: id,
    label: labelText
  }), _react["default"].createElement(_Switch.StyledSwitchCheckbox, (0, _extends2["default"])({
    disabled: disabled,
    id: id,
    type: "checkbox",
    className: "switch"
  }, ariaLabelledBy && {
    'aria-labelledby': ariaLabelledBy
  }, ariaDescribedBy && {
    'aria-describedby': ariaDescribedBy
  }, props, {
    "data-testid": "".concat(dataTestId, "_checkbox")
  }))));
});
Switch.propTypes = {
  labelText: _propTypes["default"].string,
  id: _propTypes["default"].string,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  'data-testid': _propTypes["default"].string,
  'aria-labelledby': _propTypes["default"].string,
  'aria-describedby': _propTypes["default"].string
};